<template>
  <DropDownAbsolute :value="showDropDown" @input="$event ? openDropDown() : hideDropDown()">
    <div class="box pl-3">
      <div class="pt-1" v-if="label">{{ label }}</div>
      <div class="hvh-flex align-center space-between">
        <DPDSingleSelectInput
          class="grow-1"
          :value="showDropDown ? searchWord : valueText"
          :placeholder="placeholder"
          @input="openDropDown(), (searchWord = $event)"
          @paste="searchPasted"
          @click.stop="openDropDown"
          @focus="openDropDown"
          @keydown.esc="escape"
        />

        <v-icon class="ml-2 mr-1" color="#666adf" small @click="(searchWord = null), $emit('input', null)" v-if="searchWord || valueText">mdi-close</v-icon>
        <div @click.stop v-else>
          <v-icon @click="openDropDown" v-if="!showDropDown">mdi-menu-down</v-icon>
          <v-icon @click="hideDropDown" v-else>mdi-menu-up</v-icon>
        </div>
      </div>
    </div>
    <template #drop-down>
      <DPDSearchSingleTree class="py-2" :searchWord="searchWord" :categorySettings="categorySettings" :data.sync="data" @input="itemSelected" />
    </template>
  </DropDownAbsolute>
</template>

<script>
import { Debouncer, isObject } from '../../../../libraries/common';
import { pasteSplitted, createItemSearchId } from '../../../../libraries/dpdSearch';

import DPDSingleSelectInput from './DPDSingleSelectInput.vue';
import DropDownAbsolute from '../../dropDown/DropDownAbsolute.vue';
import DPDSearchSingleTree from './DPDSearchSingleTree.vue';

export default {
  noExport: true,
  components: { DPDSingleSelectInput, DropDownAbsolute, DPDSearchSingleTree },
  props: ['value', 'title', 'label', 'placeholder', 'categorySettings', 'tags'],
  data() {
    return {
      showDropDown: false,
      searchWord: undefined,
      data: null,
      isLoading: false,
      cancelRequest: null,
      searchDebouncer: new Debouncer(100),
    };
  },
  computed: {
    shouldSearch() {
      return this.searchWord?.length > 3;
    },
    valueText() {
      return this.value?.label;
    },
  },
  methods: {
    openDropDown() {
      if (!this.showDropDown) {
        if (this.valueText) {
          if (!this.searchWord)
            this.searchWord = this.valueText;
          if (!this.data && !this.isLoading) {
            var searchWord = this.searchWord;
            this.searchWord = null;
            this.$nextTick(() => this.searchWord = searchWord);
          }
        }
        this.showDropDown = true;
      }
    },
    hideDropDown() {
      if (this.cancelRequest)
        this.cancelRequest();
      this.data = null;
      this.searchWord = null;
      this.showDropDown = false;
    },
    searchPasted(event) {
      if (isObject(event)) {
        this.hideDropDown();
        this.$emit('paste', event);
      } else {
        var splitted = event.split(',')
          .map(f => f.trim())
          .filter(f => f);
        if (splitted.length === 1) {
          this.openDropDown();
          this.searchWord = splitted[0];
        } else if (splitted.length) {
          this.searchWord = null;
          this.hideDropDown();
          this.$notify('Criteria pasted!');

          this.isLoading = true;

          var requests = pasteSplitted(splitted, this.categorySettings);
          var emitItem = ([item, ...restOfItems]) => this.$nextTick(() => {
            var newItem = { ...item, search: item.search || createItemSearchId(item) };
            this.$emit('input', newItem);
            if (restOfItems.length)
              emitItem(restOfItems);
          });

          Promise.all(requests)
            .then(all => emitItem(all.filter(f => f)))
            .then(() => this.isLoading = false);
        }
      }
    },
    itemSelected(item) {
      if (item.type || item.id === 'searchWord') {
        this.searchWord = null;
        this.hideDropDown();
        this.$emit('input', item);

        if (item.id !== 'searchWord') {
          this.data = null;
        }
      }
    },
    escape() {
      if (this.showDropDown) {
        if (this.searchWord !== this.valueText) {
          this.searchWord = this.valueText;
        } else {
          this.searchWord = null;
          this.hideDropDown();
        }
      }
    },
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisDPDSearchSingle'] = this;
  },
}
</script>

<style lang="scss" scoped>
.box {
  position: relative;
  // padding: 5px 16px;
  border-radius: 4px;
  background-color: white;
  box-shadow: 0 1px 4px 1px rgba(6, 10, 36, 0.1), 0 5px 10px 0 rgba(6, 10, 36, 0.08);
}
</style>